var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusIconInFilters(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 17,
    height: 17,
    fill: "url(#pattern0_4341_8696)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_4341_8696",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4341_8696",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4341_8696",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAACxElEQVR4nO2dvW7UQBRGpwKegt3MBApehYqXgGqX0szdIi8GNenC8gBRQDxBoEA0H5qwI1EQeQxY986d70iWIiWxvOf4Z+21Z0MghBBCOuHiGR7kiFc54V2O+FImSXgrCS/L77SXzzWHLTaS8EES8KcpR1yVv9FeTpdMEY9zxPV98n+L8PlwjqS9vEPKF0bQly+MoC9fGEFfvjCCvnxhhOUcnuIsJ9w0yY34cTe1REi4KfP+h/XCP9OSNf+X/BcS8VwivnNLUJAfTjCCovwKIyjKrzCCovwKIyjKrzCCovwKIyjKrzCCovwKIyjKrwwfQVN+GD2CBfnDRrAkf7gIFuUPE8GyfPcRepDvNkJP8t1F6FG+mwg9y+8+ggf53UbwJL+7CB7ldxPBs3zzEUaQbzbCSPLNRRhRvpkII8tXj0D5ihEoXzEC5StGKE8aLrxF3N0+f47TndlNt8ZLwqdpg21o4WKDRznh41ry5+YZjP//30YoTovb2ZnmiNdrrvmeAizeEiL2YQ6JuFxzt+MtwKIIEZdhjhzxdS35XgO0HpiL2zCHRNwywErvjCJuW2bEXZDqLihh13hA4UE4LH4ntJsNsDvHQ0k4rhXB0zFAlp0LHIvbphnzREzxRKzCSxH3w+tBivCKqCL8TEARfio2svyRD8xiRf6IEcSa/JEiiFX5I0QQ6/I9R5Be5HuMIL3J9xRBepXvIYL0Lr/nCOJFfo8RxJv8niKIV/k9RBDv8i1HkFHkW4wgo8m3FEFGlV/hkGUG4KB9BuCwlQbgwK0G4NDFBpg4eLc+E4ev12fiFzjocyhPZvIrTPqLIKOf4f5v3jxBLLdzL4jQfIt4mbf26/O3JSSu+aYjZO529CJkytfbEjLl60XIlK8XIVP+ekwbbGdGcjkufhqRLOPuOeaIfY54LxHfyvgLp5/3zc/hEkIIIUGfnxqHGktpMp19AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusIconInFilters);
export default __webpack_public_path__ + "static/media/StatusIconInFilters.54b220a77cc5407c2e575c01df613c29.svg";
export { ForwardRef as ReactComponent };